import {Pipe, PipeTransform} from '@angular/core';
import {OrderException} from "@services";

@Pipe({
    name: 'orderException',
    standalone: true
})
export class OrderExceptionPipe implements PipeTransform {
    transform(value: OrderException | string | undefined | null): string {
        if (!value) return '';

        switch (value) {
            case OrderException.CNumberMismatch: return "C Number Mismatch";
            case OrderException.DeliveryNumberMismatch: return "Delivery Number Mismatch";
            case OrderException.PickStatusMismatch: return "Pick Status Mismatch";
            case OrderException.DeliveryDateMismatch: return "Delivery Date Mismatch";

            default: return value;
        }
    }
}
